export const websitesMock = [
  {
    _id: '64413d2223f5f71051ce6456',
    url: 'https://rhinobino.com',
    domain: 'rhinobino.com',
    lastScanDate: '2023-04-20T13:24:50.923Z',
    online: true,
    mobile: false,
    standard: 'WCAG2AA',
    verified: false,
    monitoringEnabled: true,
    crawlDelay: null,
    rootElement: '',
    hideElements: [],
    issuesInfo: {
      accessScore: null,
      accessScoreAverage: 98,
      totalIssues: 214,
      errorCount: 130,
      warningCount: 84,
      noticeCount: 0,
      pageCount: 325,
      __typename: 'IssueInfo',
    },
    pageHeaders: null,
    pageLoadTime: {
      duration: 0,
      durationFormated: '',
      __typename: 'PageLoadTimeMeta',
    },
    crawlDuration: 7411.536586999893,
    ua: '',
    actionsEnabled: null,
    robots: true,
    subdomains: false,
    tld: false,
    shutdown: false,
    ignore: [],
    rules: [],
    runners: [],
    proxy: '',
    sitemap: 0,
    theme: ['dark'],
    __typename: 'Website',
  },
  {
    _id: '6440537f23f5f71051ce6447',
    url: 'https://elegantfisherman.com',
    domain: 'elegantfisherman.com',
    lastScanDate: '2023-04-19T20:47:59.783Z',
    online: true,
    mobile: false,
    standard: 'WCAG2AA',
    verified: false,
    monitoringEnabled: true,
    crawlDelay: null,
    rootElement: '',
    hideElements: [],
    issuesInfo: {
      accessScore: null,
      accessScoreAverage: 96,
      totalIssues: 63,
      errorCount: 26,
      warningCount: 37,
      noticeCount: 0,
      pageCount: 13,
      __typename: 'IssueInfo',
    },
    pageHeaders: null,
    pageLoadTime: {
      duration: 0,
      durationFormated: '',
      __typename: 'PageLoadTimeMeta',
    },
    crawlDuration: 2383.254833996296,
    ua: '',
    actionsEnabled: null,
    robots: true,
    subdomains: false,
    tld: false,
    shutdown: false,
    ignore: [],
    rules: [],
    runners: [],
    proxy: '',
    sitemap: 0,
    theme: ['system'],
    __typename: 'Website',
  },
]
